/**
 * リリースノート英語版（DF BIRD・英語版）
 * @returns JSX.Element
 */
export const ReleaseNotesDfBirdEn = () => {
    return (
        <div>
            {/* v1.7.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.7.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-08-05</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.7.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・Added Batch processing function.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Faster loading of Ortho and DSM data.</p>
                    <p>・Improved quality when merging data after split processing.</p>
                    <p>・Optimized log output.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Reduced occurrence of memory errors during large-scale data processing.</p>
                    <p>・Other minor bug fixes.</p>
                    <br />
                </div>
            </div>

            {/* v1.6.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.6.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-05-12</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.6.2 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Improved support for Windows security features.</p>
                    <br />
                </div>
            </div>

            {/* v1.6.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.6.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-04-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.6.1 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>
                        ・Fixed an issue where newly registered users could not connect using the GNSS CORS Data
                        Download Tool.
                    </p>
                    <br />
                </div>
            </div>

            {/* v1.6.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.6.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2026-03-31</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.6.0 has been released.</p>
                    <br />
                    <p>New Features</p>
                    <p>・Supports analysis with multiband images.</p>
                    <p>・Added a GNSS CORS Data Download Tool (for PPK).</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Implemented handling to save processed files when an error occurs.</p>
                    <p>・Added an error message for image matching failures.</p>
                    <br />
                </div>
            </div>

            {/* v1.5.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.5.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-10</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.5.2 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where login failed due to Windows Update.</p>
                    <br />
                </div>
            </div>

            {/* v1.5.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.5.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-12-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.5.1 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Added Feature Extraction Accuracy "ultra".</p>
                    <p>・Partial improvement in image matching accuracy.</p>
                    <p>・Added PPK settings to Advanced Settings.</p>
                    <p>・Changed the default working folder to "Output Folder".</p>
                    <br />
                </div>
            </div>

            {/* v1.5.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.5.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-11-14</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.5.0 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・The output resolution setting has been removed.</p>
                    <p>・Geoid correction added as a tool in a separate menu.</p>
                    <p>・Support for detailed error messages.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed to continue processing even if geoid correction fails.</p>
                    <br />
                </div>
            </div>

            {/* v1.4.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.4.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-08-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.4.1 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Enhanced DSM files with an overview structure for faster loading in DF Scanner.</p>
                    <p>
                        ・Added warning messages for insufficient disk space (before processing / during error
                        occurrence).
                    </p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed memory errors in geoid height correction processing.</p>
                    <p>・Corrected errors in distance calculation.</p>
                    <p>
                        ・Fixed an issue where the values would not update even when the "Back" or "Reset" button was
                        pressed during distance/area calculations.
                    </p>
                    <br />
                    <p>Others</p>
                    <p>・Corrected some settings menu labels.</p>
                    <br />
                </div>
            </div>

            {/* v1.4.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.4.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-07-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.4.0 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Added support for applying geoid height correction to exported DSM and point cloud data.</p>
                    <p>・Added a setting to enable or disable point cloud data export.</p>
                    <p>・Added support for rolling shutter cameras (see the manual for a list of supported models).</p>
                    <p>・Improved user-side license features, including expiration notifications and proxy support.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Added compatibility with NVIDIA GeForce RTX 50 series.</p>
                    <p>・Fixed an issue where the software would not start in environments with Japanese user names.</p>
                    <br />
                </div>
            </div>

            {/* v1.3.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.3.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-06-13</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.3.0 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Improved accuracy in orthophoto and DSM generation.</p>
                    <p>・Display of the menu upon software startup.</p>
                    <p>・Added a minimize button to the processing dialog.</p>
                    <p>・Parameter adjustments.</p>
                    <br />
                </div>
            </div>

            {/* v1.2.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.2.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-04-01</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.2.0 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Processing can now be divided for large-scale data.</p>
                    <br />
                    <p>Others</p>
                    <p>
                        ・Permanent licenses are now supported (for users who have purchased DF Scanner Lite permanent
                        license).
                    </p>
                    <br />
                </div>
            </div>

            {/* v1.1.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.1.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2025-02-04</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.1.0 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Removed "Speed Priority Mode".</p>
                    <p>・Added a feature to set a working folder.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where the software might not run on certain server CPUs.</p>
                    <br />
                </div>
            </div>

            {/* v1.0.3 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.3</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-11-29</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.3 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・The accuracy of creating orthoimages has been improved.</p>
                    <p>・Automated image import when processing is complete.</p>
                    <br />
                </div>
            </div>

            {/* v1.0.2 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.2</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-11-08</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.2 has been released.</p>
                    <br />
                    <p>Improved Functions</p>
                    <p>・Speeding up SfM processing.</p>
                    <br />
                </div>
            </div>

            {/* v1.0.1 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.1</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-10-25</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.1 has been released.</p>
                    <br />
                    <p>Bug Fixes</p>
                    <p>・Fixed an issue where some PCs would not start.</p>
                    <p>・Fixed an issue where some orthoimages were not drawing properly.</p>
                    <p>・Fixed a bug in polygon drawing.</p>
                    <br />
                </div>
            </div>

            {/* v1.0.0 */}
            <div className="mb-10 rounded-lg border border-gray-300 p-4 shadow">
                <h2 className="my-2 text-3xl font-bold">DF BIRD v1.0.0</h2>
                <h2 className="my-2 text-lg font-bold text-gray-500">2024-09-18</h2>
                <hr className="my-2"></hr>
                <div>
                    <p>DF BIRD v1.0.0 has been released.</p>
                    <br />
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesDfBirdEn;
